import React, {useEffect, useState} from 'react';
import {Stack, TextField, Typography} from "@mui/material";
import {useParams} from "react-router";
import {useReportStore} from "../../../useReportStore";
import {updateReportDoc} from "../../../../../firebase/firestore/reports";
import useYDocStore from "../../../../../stores/useYDocStore";
import {applyTitleToYDocMeta} from "../../../../../utils/syncReportDocumentTitle";

const ReportTitle = ({title, role, status}) => {
    const {reportId} = useParams()
    const [editing, setEditing] = useState(false);
    const updateReport = useReportStore(s => s.updateReport)
    const ydoc = useYDocStore(s => s.ydoc);
    const yDocMeta = useYDocStore(s => s.yDocMeta);
    const [value, setValue] = useState(title ?? '');

    // New: only owners and editors may edit, and not when status is 'approved'
    const canEdit = (role === 'owner' || role === 'editor') && status !== 'approved';

    // If role changes while editing, close the editor
    useEffect(() => {
        if (editing && !canEdit) {
            setEditing(false);
            setValue(title ?? '');
        }
    }, [editing, canEdit, title]);

    useEffect(() => {
        if (editing) {
            setValue(title ?? '');
        }
    }, [editing, title]);

    useEffect(() => {
        if (!editing) {
            setValue(title ?? '');
        }
    }, [title, editing]);

    const commit = async () => {
        const next = value ?? '';
        const changed = (title ?? '') !== next;
        if (changed && reportId) {
            updateReport({title: next});
            applyTitleToYDocMeta(ydoc, yDocMeta, next);
            setEditing(false);
            // apiUpdateReport(reportId, {title: next}).then(r => null)
            void updateReportDoc(reportId, {title: next});
        } else {
            setEditing(false);
        }
    };

    const cancel = () => {
        setValue(title ?? '');
        setEditing(false);
    };

    if (editing) {
        return (
            <TextField
                variant="outlined"
                autoFocus
                fullWidth
                value={value}
                size={'small'}
                onChange={(e) => setValue(e.target.value)}
                onBlur={commit}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') commit();
                    if (e.key === 'Escape') cancel();
                }}
                placeholder="Enter a report title"
            />
        );
    }

    if (title === null || title === undefined) return null;

    if (title.length === 0) {
        return (
            <Stack
                direction={'row'}
                alignItems={'center'}
                spacing={1}
                fontStyle={'italic'}
                color={'text.secondary'}
                onClick={canEdit ? () => setEditing(true) : undefined}
                sx={{
                    cursor: canEdit ? 'pointer' : 'default',
                    // only show hover background when editable
                    '&:hover': canEdit ? {bgcolor: (theme) => theme.palette.action.hover} : undefined
                }}
            >
                <Typography variant="h6">
                    No report title.
                </Typography>
                {canEdit && <Typography variant={'caption'}>Click here to edit</Typography>}
            </Stack>
        );
    }

    return (
        <Typography
            variant="h6"
            onClick={canEdit ? () => setEditing(true) : undefined}
            sx={{
                cursor: canEdit ? 'pointer' : 'default',
                '&:hover': canEdit ? {bgcolor: (theme) => theme.palette.action.hover} : undefined
            }}
            title={canEdit ? "Click to edit" : undefined}
        >
            {title}
        </Typography>
    );
};

export default ReportTitle;